export default __webpack_public_path__ + "static/media/Greek.ed91324e.jpg";